export const MAC_NEW_ORIGIN_FLAG = 'MAC new origin';
